import { Stack, Typography } from '@mui/material';
import { ProductGroupFilter } from '@retail/components';
import { MgSupplierItemSearchField } from '@retail/products/components';
import { ProductGroup, ProductGroupCount } from '@retail/products/types';
import { usePurchaseAgreementsTFunction } from '@retail/purchase-agreements/i18n';
import { PriceTimeVariant, PurchaseAgreement } from '@retail/purchase-agreements/types';
import { useDisclosure } from '@shared/hooks';
import { AgreementWithCheckbox } from './AgreementWithCheckbox';
import { PricesToViewRadioSelect } from './PricesToViewRadioSelect';

interface Props {
  agreements: PurchaseAgreement[];
  productGroupHierarchy: ProductGroupCount[];
  selectedAgreementIds: number[];
  selectedProductGroup?: ProductGroup;
  checkedPriceType: PriceTimeVariant;
  selectAgreement: (agreement: number) => void;
  selectProductGroup: (productGroup: string | null) => void;
  setQuery: (query: string) => void;
  handleCheckPriceType: (priceType: PriceTimeVariant) => void;
}

export function PriceListFilters({
  agreements,
  productGroupHierarchy,
  selectedAgreementIds,
  selectedProductGroup,
  checkedPriceType,
  selectAgreement,
  selectProductGroup,
  setQuery,
  handleCheckPriceType,
}: Props) {
  const t = usePurchaseAgreementsTFunction();

  const { isOpen: showProductGroups, onToggle: toggleShowProductGroups } = useDisclosure(false);

  return (
    <Stack
      gap={3}
      px={2}
      overflow="auto"
      minWidth={310}
      borderLeft={(theme) => `1px solid ${theme.vars.palette.divider}`}
    >
      <Stack>
        <Stack gap={1}>
          <Typography variant="body2" color="text.secondary">
            {t('purchaseAgreements.priceList.viewPricesFor')}:
          </Typography>
          {agreements.map((agreement) => {
            return (
              <AgreementWithCheckbox
                key={agreement.id}
                agreement={agreement}
                selectedAgreementIds={selectedAgreementIds}
                selectAgreement={selectAgreement}
              />
            );
          })}
        </Stack>
      </Stack>
      <PricesToViewRadioSelect
        checkedPriceType={checkedPriceType}
        handleCheckPriceType={handleCheckPriceType}
      />

      <MgSupplierItemSearchField isDisabled={false} onSubmitSearch={setQuery} size="small" />

      <ProductGroupFilter
        productGroups={productGroupHierarchy}
        selectedProductGroup={selectedProductGroup as ProductGroup}
        showProductGroups={showProductGroups}
        toggleShowProductGroups={toggleShowProductGroups}
        selectProductGroup={selectProductGroup}
        getCount={(productGroup: ProductGroup) => productGroup.count}
      />
    </Stack>
  );
}
